import { Group } from "@mantine/core";
import urls from "../../../../../../urls";
import { splitNameExtension } from "../../../../../../utils/files/splitNameExtension";
import { getTablerIconByFileExtension } from "../../../../../BuildingBlocks/Icon/utils/getTablerIconByFileExtension";
import { DownloadLink } from "../../../../../DownloadLink/DownloadLink";

interface DocumentNameCellProps {
  documentId: number;
  documentName: string;
}

function DocumentNameCell({ documentId, documentName }: DocumentNameCellProps) {
  const [, fileExtension] = splitNameExtension(documentName);
  const Icon = getTablerIconByFileExtension(fileExtension);

  return (
    <Group gap="xs" wrap="nowrap">
      <Icon size="1.4em" stroke={1.5} />
      <DownloadLink
        className="name"
        filename={documentName}
        url={urls.api.todoDocumentDownload(documentId)}
      >
        {documentName}
      </DownloadLink>
    </Group>
  );
}

export { DocumentNameCell };
